<div
  #contentContainer [class.collapsed]="isCollapsed"
  [innerHTML]="html | safeHtml">
</div>

@if (isOverflowing) {
  <button
    pButton
    class="p-button-link p-0 mt-2"
    icon="pi pi-chevron-{{ isCollapsed ? 'down' : 'up' }}"
    label="Show {{ isCollapsed ? 'more' : 'less' }}"
    (click)="toggleContent()"
  ></button>
}